import * as z from 'zod';

export const CurrencySchema = z.enum(['gbp'])

export type Currency = z.infer<typeof CurrencySchema>;